import { api } from '../slices/api';

import {
	ShopPerformanceFilters,
	buildReportQuery,
} from '../../pages/Admin/pages/ShopPerformance/queryParams';

export interface MoneyMixBucket {
	key: string;
	label: string;
	orders: number;
	lines: number;
	total?: string;
	material_cost?: string;
	material_cost_pct?: string;
}

export interface MoneyBlock {
	orders: number;
	lines: number;
	total?: string;
	material_cost?: string;
	material_cost_pct?: string;
	by_lead_time: MoneyMixBucket[];
	by_quantity: MoneyMixBucket[];
}

export interface AverageMetric {
	days: string | null;
	n: number;
	prior_days: string | null;
	prior_n: number;
	delta_days: string | null;
}

export interface HistogramBar {
	key: string;
	label: string;
	count: number;
}

export interface CycleSection {
	line_count: number;
	averages: {
		acceptance: AverageMetric;
		material_prep: AverageMetric;
		kitting: AverageMetric;
		machine_setup: AverageMetric;
		machining_complete: AverageMetric;
		delivery: AverageMetric;
		lead_time: AverageMetric;
	};
	histogram_n: number;
	on_time_n: number;
	on_time_pct: string | null;
	histogram: HistogramBar[];
}

export interface OtherCostRow {
	code: string;
	label: string;
	cost?: string;
}

export interface ShopPerformanceResponse {
	date_from: string;
	date_to: string;
	days: number;
	prior_date_from: string;
	prior_date_to: string;
	include_revenue: boolean;
	job_cost_footnote: string;
	sales: MoneyBlock;
	revenue: MoneyBlock;
	other_costs: {
		total?: string;
		by_code: OtherCostRow[];
		footnote: string;
	};
	by_received: CycleSection;
	by_delivered: CycleSection;
}

export interface ShopPerformanceFilterOptions {
	methods: string[];
	materials: string[];
	finishes: string[];
	coatings: string[];
}

export const shopPerformanceApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getShopPerformance: builder.query<
			ShopPerformanceResponse,
			ShopPerformanceFilters
		>({
			query: (filters) =>
				`orders/reports/shop-performance/?${buildReportQuery(filters)}`,
		}),
		getShopPerformanceFilters: builder.query<ShopPerformanceFilterOptions, void>(
			{
				query: () => 'orders/reports/shop-performance-filters/',
			}
		),
	}),
});

export const {
	useGetShopPerformanceQuery,
	useGetShopPerformanceFiltersQuery,
} = shopPerformanceApi;
